// GENRES LIST
export const GENRES_LIST_LOADING = 'GENRES_LIST_LOADING';
export const GENRES_LIST_SUCCESS = 'GENRES_LIST_SUCCESS';
export const GENRES_LIST_ERROR = 'GENRES_LIST_ERROR';
